import { isNotNil } from 'es-toolkit';

import type { Nullable } from '@clearverify/types';

import type { AddressInfoFragment } from 'src/api';

type ObjWithAddressFields = Pick<AddressInfoFragment, 'street' | 'city' | 'state' | 'zipCode'>;

export const getUserHomeAddress = (address: Nullable<ObjWithAddressFields>) => {
  const addressArray = [address?.street, address?.city, address?.state, address?.zipCode].filter(
    isNotNil,
  );
  if (addressArray.length === 0) return null;

  return addressArray.join(', ');
};

export const getAddressString = (address: Nullable<AddressInfoFragment>) => {
  const addressArray = [address?.street, address?.city, address?.state, address?.zipCode].filter(
    isNotNil,
  );
  if (addressArray.length === 0) return null;

  return addressArray.join(', ');
};
